import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.2578 2.1875C20.7266 2.69531 21 3.28125 21 3.98438C21 4.6875 20.7266 5.27344 20.2578 5.74219L6.50781 19.4922L1.9375 20C1.625 20 1.39062 19.9219 1.23438 19.6875C1.03906 19.4922 0.960938 19.2578 1 18.9453L1.50781 14.4922L15.2578 0.742188C15.7266 0.273438 16.3125 0 17.0156 0C17.7188 0 18.3047 0.273438 18.8125 0.742188L20.2578 2.1875ZM5.92188 18.3203L16.2344 8.00781L12.9922 4.76562L2.67969 15.0781L2.28906 18.7109L5.92188 18.3203ZM19.3984 4.84375C19.6328 4.60938 19.75 4.33594 19.75 3.98438C19.75 3.63281 19.6328 3.32031 19.3984 3.08594L17.9141 1.60156C17.6797 1.36719 17.3672 1.25 17.0156 1.25C16.6641 1.25 16.3906 1.36719 16.1562 1.60156L13.8906 3.86719L17.1328 7.10938L19.3984 4.84375Z",
		fill: "currentColor"
	})
});
export default SvgPen;
